import React, { Fragment } from 'react';
import { injectIntl } from 'react-intl';
import { Typography, Box } from '@mui/material';

const TypoStyle = {
  fontSize: '16px',
  cursor: 'pointer'
};

const TermsAndPolicyTypography = props => {
  const { intl } = props;

  return (
    <Box style={{ display: 'flex', justifyContent: 'center', gap: 20 }}>
      <Typography onClick={() => window.open('https://www.portfoplus.com/terms.html', '_blank')} style={TypoStyle}>
        {intl.formatMessage({ id: 'terms-1' })}
      </Typography>
      <Typography onClick={() => window.open('https://www.portfoplus.com/privacy.html', '_blank')} style={TypoStyle}>
        {intl.formatMessage({ id: 'privacy-1' })}
      </Typography>
      <Typography onClick={() => window.open('https://www.portfoplus.com/?utm_source=applogin&utm_medium=button', '_blank')} style={TypoStyle}>
        {intl.formatMessage({ id: 'home' })}
      </Typography>
    </Box>
  );
};

export default injectIntl(TermsAndPolicyTypography);
